import { css, html } from 'react-strict-dom';
import { Color } from 'src/constants';

import Text from '../../../components/Text';
import { Model } from '../../../models';

type Props = {
  label: string;
  variant: Model.Ticket.ReportStatusVariant | 'green';
};

const VARIANT_COLORS: Record<
  Model.Ticket.ReportStatusVariant | 'green',
  { background: string; text: string }
> = {
  resolved: { background: Color.blueBg, text: Color.blue },
  blueGrey: { background: Color.blueGreyBg, text: Color.blueGrey },
  open: { background: Color.neutral10, text: Color.neutral60 },
  green: { background: Color.greenBg, text: Color.green },
};

/**
 * The status chip on a report row.  Resolved is the one outcome worth
 * spotting from across the list; every other resolution shares the muted
 * blue-grey chip, and a ticket with no resolution gets a quiet grey Open chip.
 */
export default function ReportStatusTag({ label, variant }: Props) {
  const colors = VARIANT_COLORS[variant];
  return (
    <html.span style={[styles.tag, styles.colors(colors)]}>
      <Text typeface="body.medium">{label}</Text>
    </html.span>
  );
}

const styles = css.create({
  tag: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    borderRadius: 8,
    paddingInline: 6,
    paddingBlock: 2,
    whiteSpace: 'nowrap',
  },
  colors: (colors: { background: string; text: string }) => ({
    backgroundColor: colors.background,
    color: colors.text,
  }),
});
